// extracted by mini-css-extract-plugin
export var measureBox = "_58-0";